import { styled } from 'styled-components';
import Input from '../../components/utils/Input/Input';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  background-color: #faf5f6;
  gap: 33px;
  padding-right: 33px;
  @media (max-width: 800px) {
    padding-top: 50px;
    padding-left: 33px;
  }
`;
export const Loader = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1800px;
`;
export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;

export const Title = styled.span`
  color: black;
  font-family: 'Poppins-Regular';

  font-size: 18px;
`;

export const LoaderContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  width: 100%;
`;
export const ButtonsContainer = styled.div`
  min-width: 310px;
  border-radius: 100px;
  min-height: 37px;
  border: 1px solid #f2f0f7;
  background: #fff;
  display: flex;
  padding: 5px 12px;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  @media (max-width: 360px) {
    min-width: unset;
  }
`;
export const Button = styled.button`
  background: #fff;
  border: none;
  outline: none;
  user-select: none;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: flex;
  &:active {
    opacity: 0.6;
  }
`;
export const ModalTitle = styled.span`
  color: #000;
  text-align: justify;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ButtonModalCancel = styled.button`
  border-radius: 16px;
  border: 1px solid #be6a59;
  display: flex;
  width: 160px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: white;
  cursor: pointer;

  color: #1e1e1e;
  text-align: justify;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;
export const ButtonModal = styled(ButtonModalCancel)`
  background: #f1e4df;
  border: none;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const IconPosition = styled.div`
  position: absolute;
  top: 13px;

  right: 24px;
  cursor: pointer;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DayContainer = styled.div`
  display: flex;
  align-items: center;

  gap: 10px;
`;

export const ModalContainer = styled.div`
  display: flex;
  overflow-y: auto;
  height: 60vh;
  flex-direction: column;
  gap: 24px;
`;

export const DayInputContainer = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 10px;
`;

export const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e2dddb;
`;

export const CheckboxContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledInput = styled(Input)`
  width: 100%;
`;

export const TimeText = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

export const AppointmentTitle = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const AppointmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const AppointmentModalContainer = styled.div`
  padding: 0px, 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;

  background: #f1e4df;
  height: 31px;
`;
export const SelectOption = styled.span`
  width: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  color: #000;

  text-align: center;
  font-family: 'Poppins-Medium';
  font-size: 14px;
  letter-spacing: -0.408px;

  border-radius: 8px;
  border: ${props => (props.$selected ? '1px solid #f3e6e1' : '1px solid #f1e4df')};
  background: ${props => (props.$selected ? '#fffdfc' : 'transparent')};
  box-shadow: ${props => (props.$selected ? '0px 2px 12px 0px rgba(0, 0, 0, 0.04)' : 'none')};
`;

export const InfoClientContainer = styled.div`
  /* display: flex; */
  width: 100%;
  position: relative;
`;
